import {SponsorshipType} from "@/types/spellify/sponshorship";
import {CSSProperties} from "react";
import {useDarkMode} from "@/components/ThemeProvider/ThemeProvider";

export const useSponsorshipBackground = (sponsorship?: SponsorshipType | null): CSSProperties => {
  const [isDarkMode] = useDarkMode()

  if (!sponsorship) return {}
  return {
    backgroundColor: isDarkMode ? sponsorship.backgroundDark : sponsorship.backgroundLight,
    backgroundImage: isDarkMode ? `url(${sponsorship.backgroundImageDark})`: `url(${sponsorship.backgroundImageLight})`,
    backgroundRepeat: 'repeat',
  }
}